export enum LoginIdentificationType {
  EMAIL = 'email',
  USERNAME = 'username'
}
